module.exports = __webpack_public_path__ + "img/PhonelinkRingOutlined.f1797084.svg";